<template>
  <div
    v-if="showBadge && isMounted"
    class="pzo-badge"
    :class="{
      'margin-bottom-xs padding-xxs': !isProductPerksEnabled,
      'margin-bottom-xxs padding-xs pzo-perk': isProductPerksEnabled,
    }"
  >
    <template v-if="isProductPerksEnabled">
      <span
        class="personalized-offers icon margin-right-xxs"
      />
      <div class="medium">
        Eligible for exclusive offer in Bag
      </div>
    </template>
    <template v-else>
      Exclusive offer: Find your discount in bag
    </template>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useMounted } from '@vueuse/core';
import { useFeatureEligibility } from '@modules/featureControl';
import usePzo from '../composables/usePzo';

const { showBadge, checkPzo } = usePzo();
const isMounted = useMounted();
const { isProductPerksEnabled } = useFeatureEligibility();
onMounted(() => {
  checkPzo();
});
</script>

<style lang="scss" scoped>
@import '~settingSCSS';
@import "@csgIcons/_personalized-offers.scss";

.pzo-badge {
  background-color: #F6D96A; // Custom color for pzo badge
  max-width: rem-calc(298);

  @include breakpoint(small only) {
    max-width: 100%;
  }
}
.pzo-perk {
  max-width: 100%;
  display: flex;
  align-items: center;
  border-radius: rem-calc(5);
}
.icon {
  min-width: rem-calc(24);
  display: flex;
}
</style>
